import { useState } from 'react';

export interface SupportCodeProps {
  traceId: string;
}

/**
 * Código de suporte (trace_id) exibido junto de todo erro acionável — discreto,
 * truncado na tela, com toque/clique para copiar o valor completo. Ver
 * `lib/errors.ts` (`describeError`) para de onde vem o `traceId`.
 */
export function SupportCode({ traceId }: SupportCodeProps) {
  const [copied, setCopied] = useState(false);
  const short = traceId.length > 8 ? `${traceId.slice(0, 8)}…` : traceId;

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(traceId);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard indisponível (contexto não seguro/permissão negada) — falha
      // silenciosa; o código continua visível no título/atributo para cópia manual.
    }
  }

  return (
    <button
      type="button"
      className="support-code"
      onClick={() => void handleCopy()}
      title={`Copiar código de suporte completo: ${traceId}`}
      aria-label={`Código de suporte ${traceId}. Tocar para copiar.`}
    >
      Código de suporte: <span className="mono">{short}</span>
      {copied ? <span className="support-code__copied"> — copiado</span> : null}
    </button>
  );
}
